import Loadable from 'components/Loadable';

const singleSearch = {
  exact: true,
  path: '/advanced-search',
  component: Loadable({
    loader: () => import('../views/advanced-search'),
  }),
};

export default singleSearch;
